const REGEX_GROUPS = /(\d)(?=(\d\d\d)+(?!\d))/g;
// Le délimiteur FR est le _Narrow No-Break Space_, eh oui !
export const useGrouping = (int: number, delimiter = '\u202f') => {
  return int.toString().replace(REGEX_GROUPS, `$1${delimiter}`);
};

export const formatTaux = (int: number) => {
  return int.toString().replace('.', ',') + ' %';
};

export const formatAmount = (int: number, delimiter = '\u202f') => {
  return int.toString().replace(REGEX_GROUPS, `$1${delimiter}`).replace('.', ',') + ' €';
};
